import { useState } from "react";
import { api, scrieTokenuri, mesajEroare } from "./api.js";
import { tr } from "./i18n.js";

export default function Login({ laAutentificare }) {
  const [email, setEmail] = useState("");
  const [parola, setParola] = useState("");
  const [eroare, setEroare] = useState("");
  const [seTrimite, setSeTrimite] = useState(false);
  const [seTrezeste, setSeTrezeste] = useState(false);

  async function trimite(e) {
    e.preventDefault();
    setEroare("");
    setSeTrezeste(false);
    setSeTrimite(true);
    try {
      const r = await api.login(email.trim(), parola, () => setSeTrezeste(true));
      scrieTokenuri({ accessToken: r.accessToken, refreshToken: r.refreshToken });
      laAutentificare(r.user);
    } catch (err) {
      setEroare(mesajEroare(err));
    } finally {
      setSeTrimite(false);
      setSeTrezeste(false);
    }
  }

  return (
    <div className="login">
      <div className="login-prezentare">
        <div className="login-marca">
          <div className="login-sigla">MT</div>
          <span>CentralSec</span>
        </div>
        <h1>{tr("Mentenanță Tehnică")}</h1>
        <p>
          {tr("Intervenții, parc instalat, SLA și costuri — pentru firme de instalări și mentenanță sisteme de securitate, și pentru departamentele tehnice care fac aceeași treabă.")}
        </p>
        <ul className="login-lista">
          <li>{tr("Fiecare operație are autor, moment și context")}</li>
          <li>{tr("Costul de achiziție și cel de vânzare, pe același element")}</li>
          <li>{tr("SLA condus de gravitatea incidentului")}</li>
          <li>{tr("Clientul își vede intervențiile, nu și marja")}</li>
        </ul>
      </div>

      <div className="login-formular">
        <form className="card" onSubmit={trimite}>
          <h2>{tr("Autentificare")}</h2>
          <p className="subtitlu">{tr("Intră cu contul primit de la administrator.")}</p>

          {eroare && <div className="eroare" role="alert">{eroare}</div>}
          {/* Nu e o eroare, deci nu arată ca una: serverul chiar pornește. */}
          {seTrezeste && (
            <p className="nota" role="status">
              {tr("Serverul pornește — prima intrare de după o pauză poate dura până la un minut. Nu închide pagina.")}
            </p>
          )}

          <div className="camp">
            <label htmlFor="email">{tr("Email")}</label>
            <input
              id="email" type="email" autoComplete="username" required
              value={email} onChange={(e) => setEmail(e.target.value)}
            />
          </div>
          <div className="camp">
            <label htmlFor="parola">{tr("Parolă")}</label>
            <input
              id="parola" type="password" autoComplete="current-password" required
              value={parola} onChange={(e) => setParola(e.target.value)}
            />
          </div>

          <button className="buton" type="submit" disabled={seTrimite || !email || !parola}>
            {seTrimite ? tr("Se verifică…") : tr("Intră în cont")}
          </button>
        </form>
      </div>
    </div>
  );
}
